import { gql } from '@apollo/client';

export const MinimumLeadCreatedDateByCompanyQuery = gql`
  query MinimumLeadCreatedDateByCompany {
    getMinimumLeadCreatedDateByCompany
  }
`;
